import Panel from '../../../../common/layout/Panel'
import DataResource from '../../../../common/v4/DataResource';
import Tabs from '../../../../common/Tabs';
import { Link, useLocation } from 'react-router-dom';

const SmsMasterCodesList = () => {
    const { pathname } = useLocation();
    const data = {
        url: '/admin/products/sms_master_code_prefixes',
        data: {
            data: [],
            metadata: []
        },
        userFilterSimple: true,
        userFilterExpandable: false,
        metadata: [
            {
                source: 'id',
                label: 'SMS Master Code ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'prefix',
                label: 'Prefix',
                type: 'text',
            },
            {
                source: 'master_code_id',
                label: 'Master Code',
                type: 'select',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    const tabs = [
        {
            name: 'SMS Master Codes',
            link: '/products/sms_master_codes'
        },
        {   
            name: 'Prefixes',
            link: '/products/sms_master_codes/prefixes'
        }
    ]
    return (
        <div>
            <Tabs tabs={tabs} />
                
            <Panel title = "SMS Master Code Prefixes"> 
            <DataResource
                addButtonText = "Create SMS Master Code Prefix"
                addButtonLink = "/products/sms_master_codes/prefixes/create"                    
                data = {data}
            />
        </Panel></div>
    )
}   

export default SmsMasterCodesList;